import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
import { formatMultilineAddress as submissionFormatMultilineAddress } from '../../../utils/format-multiline-address';
function isMultilineAddress(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  if (fieldType !== INPUT_FIELD_TYPES.BOOKINGS_ADDRESS && fieldType !== INPUT_FIELD_TYPES.MULTILINE_ADDRESS) {
    return false;
  }
  return typeof label === 'string' && typeof value === 'object' && value !== null && hasCountry(value);
}
const hasCountry = o => 'country' in o && (o.country === null || typeof o.country === 'string');
function _formatMultilineAddress(_ref, t, language) {
  var _submissionFormatMult;
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return undefined;
  }
  const addressParts = (_submissionFormatMult = submissionFormatMultilineAddress(value, t, language)) == null ? void 0 : _submissionFormatMult.split('\n');
  return {
    label: field.view.label,
    value: addressParts.length ? addressParts : null
  };
}
export function formatMultilineAddress(submission, t, language) {
  if (isMultilineAddress(submission)) {
    return _formatMultilineAddress(submission, t, language);
  }
  return undefined;
}
//# sourceMappingURL=multiline-address-preview.js.map